module.exports = {
      id: "filter-usage",
      viewBox: "0 0 28 24",
      url: __webpack_public_path__ + "assets/img/sprite-598bc0.svg#filter-usage",
      toString: function () {
        return this.url;
      }
    }